export default __webpack_public_path__ + "static/media/about-hero-3.c9433ee9.png";